import { useContext, useState } from 'react'
import { StoreContext } from '../services/Store'

// Get a setting from localstorage
export const useSetting = (name: string, defaultVal: string): [string, (v: string) => void] => {
  const store = useContext(StoreContext)
  if (store === null || store === undefined) { throw new Error('No Store Context available - make sure you add a DB store to use') }

  const [val, setVal] = useState(() => store.getSetting(name, defaultVal))
  return [val, (newVal: string) => {
    setVal(newVal)
    store.setSetting(name, newVal)
  }]
}
